<template>
  <div class="Total">
    <van-cell-group title="时数统计">
      <van-cell title="考勤合计(时)" :value="worktimes" />
      <van-cell title="替休合计(时)" :value="workovers" />
    </van-cell-group>
    <van-cell-group title="假期统计">
      <van-cell title="年假剩余(时)" :value="vsurplus" />
      <van-cell title="替休剩余(时)" :value="rsurplus" />
    </van-cell-group>
  </div>
</template>
<script>
import request from '@/utils/request'
const moment = require('moment')

export default {
  name: 'Total',
  components: {},
  data() {
    return {
      worktimes: 0.00,
      workovers: 0.00,
      vsurplus: 0.00,
      rsurplus: 0.00
    }
  },
  created: function() { },
  methods: {
    onRefresh(data) {
      this.worktimes = 0.00
      this.workovers = 0.00
      this.vsurplus = 0.00
      this.rsurplus = 0.00

      const self = this
      let work_times = 0.00
      let work_overtimes = 0.00
      data.forEach(element => {
        work_times = work_times + element.work_times
        work_overtimes = work_overtimes + element.over_times
      })
      this.worktimes = work_times.toFixed(2)
      this.workovers = work_overtimes.toFixed(2)
      request({ url: '/O00001/AnnualVacation', params: { user_code: this.$parent.params.user_code, apply_date: moment().format('YYYY-MM-DD'), pcOrMobile: 'mobile' }, requestUrlKey: true })
        .then(function(response) {
          if (response[0] === 'Succeeded') {
            self.vsurplus = response[1] - response[2]
            self.rsurplus = response[3]
          }
          // self.vsurplus = (response.data.vacation - response.data.v_surplus).toFixed(2)
          // self.rsurplus = response.data.r_surplus.toFixed(2)
        })
    }
  }
}
</script>
